import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES, PRICE_LABEL, PRICE_STRIKE_LABEL } from '../data/offer';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-navy-900 text-white" data-id="element-47" data-mp="9ll6ipqopkjt">
      <img src={IMAGES.hero} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-48" data-mp="4mruz2uyk3ma" />
      <div className="absolute inset-0 bg-navy-950/70" aria-hidden="true" data-id="element-49" data-mp="128pft6wt8l1e" />
      <div className="relative mx-auto grid max-w-6xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-16 lg:py-24" data-id="element-50" data-mp="xbpaiy7sbmbc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-51" data-mp="nc89iu3h9wlp">
          <h1 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-[3.4rem]" data-id="element-52" data-mp="3czfme2gnud7m">
            Empezá a enseñar pickleball con{' '}
            <span className="text-lime-400" data-id="element-53" data-mp="3j9ty8ric7ai4">este pack</span>
          </h1>
          <p className="mt-4 font-display text-lg font-semibold text-navy-200 sm:text-xl" data-id="element-54" data-mp="3o7vllomspvze">
            Acá tenés todo lo que necesitás.
          </p>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-55" data-mp="39cfk4yjvyxsz">
            El sistema táctico de <strong className="font-semibold text-white" data-id="element-56" data-mp="30i18d5yke5em">«Ajedrez en la Red»</strong>{' '}
            que transforma a principiantes en jugadores avanzados.
          </p>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-57" data-mp="35a2fkdgvl5xs">
            <CtaButton size="lg" location="hero" data-id="element-58" data-mp="2qlepuntpnqfr">
              Quiero dominar la pista
            </CtaButton>
            <div className="text-sm text-white/70" data-id="element-59" data-mp="2vgu075sif47f">
              <span className="font-display text-xl font-extrabold text-white" data-id="element-60" data-mp="2hix2u768etrp">{PRICE_LABEL}</span>{' '}
              <span className="line-through decoration-lime-400/70" data-id="element-61" data-mp="2ll0i76w0uii9">{PRICE_STRIKE_LABEL}</span>
              <div data-id="element-62" data-mp="s2b7vyavsj55">ARS · Acceso digital inmediato</div>
            </div>
          </div>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/75" data-id="element-63" data-mp="nat65811aej4">
            {['Manual + 3 bonus', 'Garantía de 7 días', 'Leelo hoy en tu celular'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-64" data-mp="ddf2ya44fm8r">
                <CheckIcon className="h-4 w-4 text-lime-400" aria-hidden="true" data-id="element-65" data-mp="db2c17gdy1jk" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-66" data-mp="16346ov87u0e2">
          <div className="overflow-hidden rounded-2xl bg-white p-4 shadow-card" data-id="element-67" data-mp="x37falufynfb">
            <img src={IMAGES.devices} alt="El manual Dominio del Pickleball abierto en un iPad y un iPhone" className="w-full rounded-lg" data-id="element-68" data-mp="3lu9vowr7fq94" />
          </div>
          <p className="mt-3 text-center text-xs uppercase tracking-wide text-white/60" data-id="element-69" data-mp="1x784bltydnt2">
            Producto digital · PDF optimizado para celular y tablet
          </p>
        </motion.div>
      </div>
    </section>;
}